import { useQuery } from '@tanstack/react-query';
import { conciergeAPI, ILearningUpdateStatus } from 'api/concierge';

export const TERMINAL_LEARNING_UPDATE_STATUSES = ['succeeded', 'partial', 'failed', 'cancelled'];
const LEARNING_UPDATE_POLL_INTERVAL_MS = 10000;
const LEARNING_UPDATE_FOLLOW_UP_HEARTBEAT_MS = 60000;

export const learningUpdateStatusQueryKey = (runUid: string) => ['concierge', 'learning-update-status', runUid];

export function learningUpdateStatusPollIntervalMs(status?: ILearningUpdateStatus): number | false {
    if (!status || !TERMINAL_LEARNING_UPDATE_STATUSES.includes(status.run.status)) {
        return LEARNING_UPDATE_POLL_INTERVAL_MS;
    }

    // A finished run whose follow-up list is still open keeps a slow heartbeat:
    // the steward resolves those questions in another tab, and the app-wide
    // client disables refetchOnWindowFocus/refetchOnMount, so stopping here
    // would freeze the list until a full page reload.
    return status.follow_up?.available && status.follow_up.items.length > 0
        ? LEARNING_UPDATE_FOLLOW_UP_HEARTBEAT_MS
        : false;
}

export default function useLearningUpdateStatusQuery(runUid: string) {
    return useQuery({
        queryKey: learningUpdateStatusQueryKey(runUid),
        queryFn: () => conciergeAPI.getLearningUpdateStatus(runUid),
        refetchInterval: (query) => learningUpdateStatusPollIntervalMs(query.state.data),
    });
}
